//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'
import { Field } from 'react-final-form'

// eslint-disable-next-line import/no-named-default
import { default as IntegerInputField } from 'components/Shared/IntegerField/Index'
import { customIsEqual } from './utils'

const FieldComponent = ({
  value,
  onChange,
  disabled,
  minNumber,
  defaultValue,
}) => {
  return (
    <IntegerInputField
      value={value}
      onChange={onChange}
      disabled={disabled}
      minNumber={minNumber}
      defaultValue={defaultValue}
    />
  )
}

FieldComponent.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  minNumber: PropTypes.number,
  defaultValue: PropTypes.number,
}

const IntegerField = ({ name, validate, disabled, minNumber, defaultValue }) => {
  return (
    // without custom parse empty values are not passed to onSubmit() so API doesn't get cleared strings
    // see https://github.com/final-form/react-final-form/issues/130#issuecomment-425482365
    <Field
      name={name}
      isEqual={customIsEqual}
      validate={validate}
      parse={value => (value)}
    >
      {({ input, meta }) => {
        return (
          <FieldComponent
            value={input.value}
            onChange={input.onChange}
            disabled={disabled}
            minNumber={minNumber}
            defaultValue={defaultValue}
          />
        )
      }}
    </Field>
  )
}

IntegerField.propTypes = {
  name: PropTypes.string,
  validate: PropTypes.func,
  disabled: PropTypes.bool,
  minNumber: PropTypes.number,
  defaultValue: PropTypes.number,
}

export default IntegerField
